export const rotationOptions = [
  {
    value: ` 0`,
    label: "0",
  },
  {
    value: "90",
    label: "90",
  },
  {
    value: "180",
    label: "180",
  },
  {
    value: ` 270`,
    label: "270",
  },
];
export const unitOfMeasurementOptions = [
  { value: "Lines", label: "Lines" },
  { value: "Units", label: "Units" },
];

export const taskTypeOptions = [
  { value: "PICK", label: "PICK" },
  { value: "PUT", label: "PUT" },
];

export const timeframeOptions = [
  { value: "Current Day", label: "Current Day" },
  { value: "Last Hour", label: "Last Hour" },
];
